import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

interface ImagePreviewDialogData {
  imageUrl: string;
}

@Component({
  selector: "app-image-preview",
  templateUrl: "./image-preview.component.html",
  styleUrls: ["./image-preview.component.scss"],
  standalone: false,
})
export class ImagePreviewComponent {
  zoom = 1;
  readonly minZoom = 0.5;
  readonly maxZoom = 4;
  readonly zoomStep = 0.25;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImagePreviewDialogData,
    private dialogRef: MatDialogRef<ImagePreviewComponent>
  ) {}

  zoomIn() {
    this.zoom = Math.min(this.zoom + this.zoomStep, this.maxZoom);
  }

  zoomOut() {
    this.zoom = Math.max(this.zoom - this.zoomStep, this.minZoom);
  }

  resetZoom() {
    this.zoom = 1;
  }

  close() {
    this.dialogRef.close();
  }

  onWheel(event: WheelEvent) {
    event.preventDefault();
    if (event.deltaY < 0) {
      this.zoomIn();
    } else {
      this.zoomOut();
    }
  }
}
